import { Grid2, IconButton, Typography } from "@mui/material"
import Container from "../Container"
import { useApp } from "../../contexts/AppContext"
import { IBranch } from "sierra"
import { memo, useCallback, useState } from "react"
import ConfirmDialog from "../ConfirmDialog"
import { Close, Edit } from "@mui/icons-material"
import api from "../../utils/axios"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../hooks/useAuth"

const BranchCard = memo(({ branch, hideButtons = false, clickable = false, index }: { branch: IBranch, hideButtons?: boolean, clickable?: boolean, index?: number }) => {
    const { lang, translate, screenSize } = useApp()
    const { user } = useAuth()
    const navigate = useNavigate()


    const [open, setOpen] = useState<boolean>(false)

    const handleDeleteBranch = useCallback((branchId: number) => {
        api.delete(`branches/${branchId}`, { meta: { showSnackbar: true } })
            .catch(console.error)
            .finally(() => setOpen(false))
    }, [])

    const handleNavigateToService = useCallback(() => navigate('services', { state: { branch: branch } }), [])

    return (
        <Container className={screenSize.xs ? undefined : `fadeOut`} size={'grow'} minWidth={{ xs: '100%', lg: '20vw' }} height={'30vh'} onClick={clickable ? handleNavigateToService : undefined} sx={{
            '&:hover': {
                transform: 'translateY(-10px)',
            },
            transition: 'transform 0.4s ease',
            cursor: clickable ? 'pointer' : undefined
        }}>
            <Grid2 container borderRadius={2} height={'100%'} sx={{
                backgroundImage: `url(${branch.branch_header_url})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}

            >
                <Grid2 container size={'grow'} flexDirection={'column'} justifyContent={'space-between'} padding={3} sx={{ background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 80%)' }}>
                    <Grid2 container display={'flex'} justifyContent={hideButtons ? 'end' : 'space-between'}>
                        {user && !hideButtons &&
                            <Container container blur size={'auto'} display={'flex'} alignItems={'center'} paddingX={1} spacing={2}>
                                <Grid2 display={user.role === 'admin' ? 'flex' : 'none'}>
                                    <ConfirmDialog
                                        title={translate('Branch Delete')}
                                        text={translate('Are you sure you want to delete this branch?')}
                                        open={open}
                                        setOpen={setOpen}
                                        component={<BranchCard branch={branch} hideButtons={true} />}
                                        onConfirm={() => handleDeleteBranch(branch.branch_id)}>
                                        <IconButton color="error" sx={{ backgroundColor: 'rgba(255, 0, 0, 0.1)', border: '1px solid red' }} onClick={() => setOpen(true)}>
                                            <Close fontSize="small" />
                                        </IconButton>
                                    </ConfirmDialog>
                                </Grid2>
                                <Grid2>
                                    <IconButton color="info" sx={{ backgroundColor: 'rgba(0, 119, 255, 0.1)', border: '1px solid blue' }} onClick={() => {
                                        navigate('update', { state: { branch: branch, refresh: true } })
                                    }}>
                                        <Edit fontSize="small" />
                                    </IconButton>
                                </Grid2>
                            </Container>
                        }

                        <Grid2 width={{ xs: 50, lg: '4vw' }} height={{ xs: 50, lg: '4vw' }}>
                            <img src={branch.branch_logo_url} style={{ width: '100%', height: '100%', borderRadius: 50 }} />
                        </Grid2>
                    </Grid2>
                    <Grid2>
                        <Typography color='white' variant='h5'>
                            {branch.branch_name[lang] || Object.entries(branch.branch_name).find(([key, value]) => value !== null && value !== "" && value !== undefined)?.[1]} {user && user.role !== 'customer' && `(#${branch.branch_id})`}
                        </Typography>
                    </Grid2>
                </Grid2>
            </Grid2 >
        </Container>
    )
})

export default BranchCard